import { useInfiniteQuery } from "@tanstack/react-query";
import { apiFetch } from "./client";

export interface AgentStreamItem {
  id: string;
  called_at: string;
  lineage: string;
  session_id: string | null;
  message_type: string;
  author: "human" | "agent" | "tool" | "system";
  payload: unknown;
}

export interface AgentStreamPage {
  items: AgentStreamItem[];
  nextCursor: string | null;
}

export function useAgentStream(lineage: string, limit: number = 30) {
  return useInfiniteQuery<AgentStreamPage>({
    queryKey: ["agent-stream", lineage],
    initialPageParam: undefined,
    queryFn: async ({ pageParam }) => {
      const params = new URLSearchParams();
      params.set("lineage", lineage);
      params.set("limit", String(limit));
      if (pageParam) params.set("cursor", pageParam as string);
      return apiFetch<AgentStreamPage>(`/api/dev/agent-stream?${params.toString()}`);
    },
    getNextPageParam: (last) => last.nextCursor ?? undefined,
    refetchInterval: 15_000,
  });
}
